class popupForm {
  constructor() {
    const submitBtn = document.querySelector('.popup-form-action--submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        this.loadingSpinner();
        this.submittedForm();
      });
    }

    const consentCheckbox = document.getElementById('popupConsent');
    if (consentCheckbox && submitBtn) {
      consentCheckbox.addEventListener('change', () => {
        submitBtn.disabled = !consentCheckbox.checked;
      });
    }

    const copyBtn = document.querySelector('[data-cc-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => this.copyCode(copyBtn));
    }
  }

  copyCode(btn) {
    const code = btn.dataset.ccCopyCode;
    if (!code) return;
    navigator.clipboard.writeText(code).then(() => {
      btn.classList.add('copied');
      setTimeout(() => btn.classList.remove('copied'), 2000);
    });
  }

  loadingSpinner() {
    document.querySelector('.popup--button-container').classList.add('active');
  }

  submittedForm() {
    const emailInput = document.getElementById('popupEmail').value;

    // Check if email is valid before proceeding
    if (!this.validateEmail(emailInput)) {
      document.querySelector('.popup--validation').classList.remove('is-hidden');
      document.querySelector('.popup--button-container').classList.remove('active');
      return;
    } else {
      // Hide validation error if previously shown
      document.querySelector('.popup--validation').classList.add('is-hidden');
    }

    const options = {
      method: 'POST',
      headers: {
        revision: '2023-02-22',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            list_id: 'THnyVs',
            custom_source: 'First Orders 20% Off',
            email: emailInput,
            properties: { newKey: '' }
          }
        }
      })
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=WPuDdH', options)
      .then(async response => {
        if (response.status === 202) {
          setTimeout(() => {
            document.querySelector('.popup--success').classList.remove('is-hidden');
            document.querySelector('.popup-form--content').classList.add('success');

            // Set the cookie now so a refresh won't re-trigger the popup.
            // The popup stays open until the user closes it via the X button.
            const popup = document.querySelector('[data-cc-popup]');
            if (popup) {
              const cookieName = popup.dataset.ccCookieName;
              const isLoggedIn = popup.dataset.ccLoggedIn === 'true';
              const cookieDuration = isLoggedIn ? 7 * 24 * 60 * 60 * 1000 : 1 * 24 * 60 * 60 * 1000;
              if (cookieName) {
                const expiry = new Date(Date.now() + cookieDuration);
                document.cookie = `${cookieName}=true;expires=${expiry.toUTCString()};path=/`;
              }
            }
          }, 800);
        } else {
          const errorBody = await response.text();
          console.error('Klaviyo subscription error:', response.status, errorBody);
          setTimeout(() => {
            document.querySelector('.popup--error').classList.remove('is-hidden');
            document.querySelector('.popup--button-container').classList.remove('active');
          }, 500);
        }
      })
      .catch(err => {
        console.error('Error submitting form:', err);
      });
  }

  validateEmail(email) {
    // Basic email regex validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
}

new popupForm();